import React from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip,
} from '../../styles';
import { textEllipse } from '../../../../../../../core/utils/text-format-helper';
import { ContainerRequestedBy, RequestedBy } from './style';
import { DRAFT_STATUS_REQUESTED, MAX_USERNAME_LENGTH } from './constant';

function PendingApprovalStatus(props) {
  const { requestedReviewers } = props;

  const renderRequestedUsers = (requestedApproval) => requestedApproval?.map((requestedToUser) => {
    const { firstName, lastName } = requestedToUser?.user?.profile || {};
    return `${firstName} ${lastName}`;
  }).join(', ');

  return (

    <>
      {`${DRAFT_STATUS_REQUESTED}`}
      <ContainerRequestedBy>
        <RequestedBy>
          <Tooltip
            content={renderRequestedUsers(requestedReviewers)}
            trigger={(
              <ContainerRequestedBy>
                <RequestedBy>
                  {textEllipse('Needs Approval', MAX_USERNAME_LENGTH)}
                </RequestedBy>
              </ContainerRequestedBy>
            )}
          />
        </RequestedBy>
      </ContainerRequestedBy>
    </>
  );
}

PendingApprovalStatus.defaultProps = {
  requestedReviewers: {},
};

PendingApprovalStatus.propTypes = {
  requestedReviewers: PropTypes.shape({
    id: PropTypes.string,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  }),
};

export default PendingApprovalStatus;
